import { DataModel } from "common/models/utility-models/base-model";

export class DashboardModel extends DataModel {
    selectedFromDate: any = '';
    selectedToDate: string = '';
    selectedYearRange: string = '';
}